import React from 'react'
import { Box } from '@vp/swan'
import { SizeFit } from '@vp/lat-react-component-library'

import { useProject } from '../../../root/contexts/ProjectContext'
import { useSizeChartContext } from '../../contexts/SizeChartContext'

const SizeFitContainer: React.FC = () => {
  const { sizeFitKey } = useProject()
  const { isSizeChartLoaded, handleSizeChartClick } = useSizeChartContext()

  return (
    <>
      {sizeFitKey && (
        <Box className="qsp-project-quantity-section qsp-project-quantity-section-grey" backgroundColor="strong" mb="between-subsections">
          <SizeFit
            fitKey={sizeFitKey}
            onClickSizeChart={handleSizeChartClick}
            shouldShowSizeChartLink={isSizeChartLoaded}
            shouldIncludeDescription={true}
            paddingX={5}
            paddingY={4}
          />
        </Box>
      )}
    </>
  )
}

export default SizeFitContainer
